import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router';
import Table, { Head, Body, Row, Cell, Caption } from '../Components/Tabla/Tabla';
import Loading from "../../components/Loading/Loading";
import { findFactura } from "./Fetch/FindFactura";
import { parseFile } from "./Functions/parseb64toFile";
import PDF from '../../sources/Icons/PDF.svg'
import XML from '../../sources/Icons/XML.svg'
import './css/factura-show.css';
export default function FacturaShow() {

  const params = useParams();
  const [cfdis, setCfdis] = useState([])

  useEffect(() => {

    findFactura(params.hash).then(res => {
      //console.log(res)
      setCfdis(v => (
        res.map(el => ({
          ...el,
          pdf: parseFile(el.pdf, 'application/pdf'),
          xml: parseFile(el.xml, 'text/xml')
        })
        )))
    })

  }, [params])


  return (
    <div className='FacturaShow'>

      {
        cfdis.length > 0 ?
      
        cfdis.map((cfdi, incfdi) => (
          <Table key={incfdi}>
            <Caption>Factura</Caption>
            <Head>
              <Row>
                <Cell>{cfdi.Descripcion}</Cell>
              </Row>
            </Head>
            <Body>
              <Row>
                <Cell><span>Razón Social de Receptor</span></Cell>
                <Cell><span>{cfdi.RazonSocial_Receptor}</span></Cell>
                <Cell><span>RFC</span></Cell>
                <Cell><span>{cfdi.RFC_Receptor}</span></Cell>
                <Cell><span>UUID</span></Cell>
                <Cell><span>{cfdi.UUID}</span></Cell>
                <Cell><span>Fecha de Emisión</span></Cell>
                <Cell><span>{cfdi.Fecha}</span></Cell>
                <Cell className="Doc"><span>Documentos</span></Cell>
                <Cell>
                  <Link download={`${cfdi.UUID}.pdf`}
                    to={cfdi.pdf}
                    reloadDocument>
                    <img src={PDF} alt="PDF" />
                  </Link>
                  <Link download={`${cfdi.UUID}.xml`}
                    to={cfdi.xml}
                    reloadDocument>
                    <img src={XML} alt="XML" />
                  </Link>
                </Cell>
              </Row>
            </Body>
          </Table>
        ))
      
      :
      <Loading/>
    }
      
    </div>
  )
}
